export enum ScenarioType {
    Ambitious,
    MidRange,
    SmallBudget
}